export default __webpack_public_path__ + "static/media/cropped-loog-pperfil-192x192.70d447ca.png";